// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"45b1a5ed","184":"c7796d36","672":"2d765d30"}[chunkId] + ".chunk.js";
};